import React from "react";
import { motion } from "framer-motion";
import { FiMapPin } from "react-icons/fi";

const experiences = [
    {
        project: "US-Based Tech Company",
        role: "Frontend Developer · Remote",
        location: "USA",
        text: "Working remotely as a frontend developer for a company in the United States, building modern web applications with Next.js.",
        tags: ["Next.js", "AWS", "Remote Work"],
        current: true,
    },
    {
        project: "One Way Food",
        role: "Frontend Developer · Freelance",
        location: "Finland",
        text: "Built the frontend of a food ordering platform serving customers in Finland — a smooth browsing-to-checkout experience.",
        tags: ["React", "Freelance"],
    },
    {
        project: "Orange Publicity",
        role: "Frontend Developer · Freelance",
        location: "California, USA",
        text: "Built the frontend of a marketplace platform where businesses register, manage inventory, and sell through their own storefront. Integrated Stripe and PayPal payment gateways.",
        tags: ["Next.js", "Stripe", "PayPal"],
    },
    {
        project: "CineArtLink",
        role: "Frontend Developer · Freelance",
        location: "Hong Kong",
        text: "Collaborated with a Hong Kong-based company as a freelance frontend developer, turning designs into responsive interfaces.",
        tags: ["React", "Freelance"],
    },
    {
        project: "N-Hub",
        role: "Frontend Developer",
        location: "Nepal",
        text: "Worked with the Nepali startup N-Hub as a frontend developer, contributing to their product's user interface.",
        tags: ["React", "Startup"],
    },
];

const Experience = () => {
    return (
        <section className="section" id="experience">
            <motion.h2
                className="section-title"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <span className="section-number">02.</span> Where I've Worked
            </motion.h2>

            <div className="experience-list">
                {experiences.map((exp, i) => (
                    <motion.div
                        key={exp.project}
                        className="experience-card"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: i * 0.08 }}
                    >
                        <div className="experience-head">
                            <div>
                                <h3 className="experience-project">
                                    {exp.project}
                                    {exp.current && (
                                        <span className="badge-current">
                                            Now
                                        </span>
                                    )}
                                </h3>
                                <p className="experience-role">{exp.role}</p>
                            </div>
                            <span className="experience-location">
                                <FiMapPin /> {exp.location}
                            </span>
                        </div>
                        <p className="experience-text">{exp.text}</p>
                        <div className="project-tags">
                            {exp.tags.map((tag) => (
                                <span key={tag}>{tag}</span>
                            ))}
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default Experience;
